import styled from 'styled-components'

import { Colors, mediaQueries } from '@fourthwall/components'

export const TitleContainer = styled.div`
  margin-bottom: 12px;

  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`

export const Title = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 1.5;
  color: ${Colors.GS1000};

  ${mediaQueries.tablet} {
    font-size: 16px;
  }
`

export const SkipButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  line-height: 150%;
  color: ${Colors.GS600};

  &:hover {
    color: ${Colors.GS1000};
  }
`

export const Progress = styled.div`
  margin-bottom: 20px;
  height: 10px;
  background: ${Colors.GS300};
  border-radius: 100px;
  overflow: hidden;
`

export const ProgressFill = styled.div`
  height: 100%;
  background: ${Colors.G300};
`
